import { InternalServerError } from '@/features/errors';

const SomethingWentWrong = () => {
  return <InternalServerError />;
};

export default SomethingWentWrong;
